import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { getInventoryStatusLabel } from "../../utils"

import { InventoryStatus } from "@/graphql/codegen/graphql"

interface ProductInventoryStatusChipProps {
  status: InventoryStatus
}

const STATUS_TO_CLASS_NAME: Record<InventoryStatus, string> = {
  [InventoryStatus.Good]: "bg-tertiary-green-100",
  [InventoryStatus.Low]: "bg-tertiary-yellow-100",
  [InventoryStatus.Out]: "bg-secondary-200",
  [InventoryStatus.OnHold]: "bg-gray-100",
} as const

export const ProductInventoryStatusChip: FC<ProductInventoryStatusChipProps> = ({ status }) => (
  <Chip
    className={twMerge("h-6 rounded-sm text-xs", STATUS_TO_CLASS_NAME[status])}
    label={getInventoryStatusLabel(status)}
  />
)
